import { render, staticRenderFns } from "./BlocInfosMobile.vue?vue&type=template&id=491c6520"
import script from "./BlocInfosMobile.vue?vue&type=script&lang=js"
export * from "./BlocInfosMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports